import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { selectIsAuth } from "../redux/slices/auth";

/**
 * Пускает на страницу только авторизованного админа.
 *
 * Важно: проверка токена (/auth/me) асинхронная. Пока статус "loading",
 * мы НЕ редиректим — иначе залогиненного пользователя выкинет на логин
 * при перезагрузке страницы, до ответа сервера.
 */
export default function ProtectedRoute({ children }) {
  const isAuth = useSelector(selectIsAuth);
  const status = useSelector((state) => state.auth.status);

  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center text-neutral-500">
        Загрузка...
      </div>
    );
  }

  if (!isAuth) {
    return <Navigate to="/admin/auth" replace />;
  }

  return children;
}
